import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { ItemID } from "../newComponents/GeneralClasses";
import db from "../firebase";
import { ConstVariables } from "./ConstantVariables";

const AddToNotificationDB = (title, body, imageUrl, postID, otherID, topic, user_email) => {
    return new Promise(async(resolve,reject)=>{
        try {
            const docID = ItemID();
              await setDoc(doc(db,ConstVariables.NOTIFICATION_TEST_PATH,docID),{
                docID,
                title,
                body,
                imageUrl,
                postID,
                otherID,
                topic,
                user_email,
                timestamp: serverTimestamp()
              });
              resolve(true);
        } catch {
            reject("an error occurred");
        }
    });
}
export default AddToNotificationDB;